import React, {Component} from 'react'
import DBHelper from '../helpers/db'
import CircularProgress from '@material-ui/core/CircularProgress'


export default class ProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({
      currentUser: DBHelper.currentUser()
    }, ()=>{
      this.setState({loading: false})
    })
  }

  render() {
    const {loading, currentUser} = this.state

    return loading && !currentUser
      ? (
        <div style={Styles.container}>
          <CircularProgress
            size={50}
            left={70}
            top={0}
            color="secondary"
            style={Styles.refresh}/>
        </div>
      )
      : (
        <div style={Styles.formStyle}>
          <div>{this.state.currentUser.displayName}</div>
        </div>
      );
  }
}

const Styles = {
  container: {
    position: 'relative'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  },
  mainLoader: {
    position: 'absolute',
    paddingTop: '15%',
    width: '100%',
    height: '100%',
    zIndex: 1000,
    backgroundColor: '#000000',
    opacity: 0.5,
    textAlign: 'center'
  },
  formStyle: {
    padding: 20
  }
};



// WEBPACK FOOTER //
// ./src/components/ProfileScreen.js